"use strict";

require("core-js/modules/es.object.assign.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAEDropdown = void 0;

require("core-js/modules/web.dom-collections.iterator.js");

var _react = _interopRequireWildcard(require("react"));

var _Popover = _interopRequireDefault(require("@material-ui/core/Popover"));

var _ExitToApp = _interopRequireDefault(require("@material-ui/icons/ExitToApp"));

var _FAEText = require("../FAEText/FAEText");

require("./FAEDropdown.scss");

const _excluded = ["label", "icon", "href"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const FAEDropdown = _ref => {
  let {
    isLogin,
    label,
    icon,
    list = [],
    userStatus,
    userStatusSignedInLabel = "Sign In",
    userStatusSignedOutLabel = "Log Out",
    userStatusSignedInIcon = /*#__PURE__*/_react.default.createElement(_ExitToApp.default, null),
    userStatusSignedOutIcon = /*#__PURE__*/_react.default.createElement(_ExitToApp.default, null),
    signInClicked,
    signOutClicked,
    primary
  } = _ref;
  const accountDropdown = (0, _react.useRef)();
  const [anchorEl, setAnchorEl] = (0, _react.useState)(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--account-dropdown-container",
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "fae--account-dropdown",
    onClick: handleClick,
    ref: accountDropdown,
    "aria-describedby": id
  }, /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, {
    primary: primary
  }, label), icon), /*#__PURE__*/_react.default.createElement(_Popover.default, {
    id: id,
    open: open,
    anchorEl: anchorEl,
    onClose: handleClose,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "right"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "right"
    },
    onClick: handleClose
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--account-dropdown-list"
  }, list.map((item, index) => {
    const {
      label,
      icon,
      href = ""
    } = item,
          rest = _objectWithoutProperties(item, _excluded);

    return href === "" ? /*#__PURE__*/_react.default.createElement("div", _extends({
      key: index,
      className: "fae--account-dropdown-list-item"
    }, rest), icon, /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, {
      subHeading: window.screen.width > 600 ? false : true
    }, label)) : /*#__PURE__*/_react.default.createElement("a", {
      key: index,
      className: "fae--account-dropdown-list-item",
      target: "_blank",
      href: href,
      rel: "noreferrer"
    }, icon, /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, {
      subHeading: window.screen.width > 600 ? false : true
    }, label));
  }), userStatus ? !isLogin ? /*#__PURE__*/_react.default.createElement("div", {
    onClick: signInClicked,
    className: "fae--account-dropdown-list-item fae--account-dropdown-btn"
  }, userStatusSignedInIcon, /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, null, userStatusSignedInLabel)) : /*#__PURE__*/_react.default.createElement("div", {
    onClick: signOutClicked,
    className: "fae--account-dropdown-list-item fae--account-dropdown-btn"
  }, userStatusSignedOutIcon, /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, null, userStatusSignedOutLabel)) : ""))));
};

exports.FAEDropdown = FAEDropdown;